<template>
  <transition name="fade" v-if="message || error">
    <div class="message"><span class="help">{{message || error}}</span></div>
  </transition>
</template>

<script>
const messageTimeout = 3000
const errorTimeout = 5000

export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    messageTimeout: {
      type: Number,
      default: messageTimeout
    }
  },
  watch: {
    message: function () {
      setTimeout(() => { this.$emit('clearMessage') }, this.messageTimeout)
    },
    error: function () {
      setTimeout(() => { this.$emit('clearError') }, errorTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.message {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 17;
  text-align: center;
  width: 100%;
  height: auto;
  color: white;
  font-weight: 500;
  border-radius: 0;
  opacity: 0.9;
  margin: auto !important;
  background-color: $fade-message-color;
  padding: 1em;

  span {
    font-size: 1em;
    color: white;
    margin-left: 10em;
    margin-right: 10em;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}

</style>
